import { motion } from 'framer-motion'
import React from 'react'
import { useTable } from 'react-table'
import SelfExcludingSelectInput from '../FormElements/SelfExcludingSelectInput'
import classNames from 'classnames'

type Props = {
  data: Array<any>
  columns: Array<any>
  rowsOptions: Array<any>
}

const CustomersUploadColumnsMapper = ({
  data,
  columns,
  rowsOptions,
}: Props): JSX.Element => {
  const tableInstance = useTable({ columns, data: data?.slice(0, 200) })
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance
  return (
    <motion.table
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      {...getTableProps()}
      className={'table-auto'}>
      <thead className={'sticky top-0 bg-gray-100 z-30'}>
        {
          // Loop over the header rows
          headerGroups.map((headerGroup, index) => (
            // Apply the header row props
            <tr
              className={`${index === 0 ? '' : ''} h-[50px] text-left `}
              {...headerGroup.getHeaderGroupProps()}
              key={index}>
              {
                // Loop over the headers in each row
                headerGroup.headers.map((column, i, array) => (
                  // Apply the header cell props
                  <th
                    className={classNames('text-xs', {
                      'font-bold px-2 z-10 bg-[cultured-gray] shadow-[inset_2px_2px_0_cultured-gray,inset_0_-2px_0_cultured-gray]':
                        index !== 0,
                      'bg-white shadow-[inset_0_-2px_0_0_gainsboro-gray,inset_0_2px_0_0_gainsboro-gray]':
                        index === 0,
                      'shadow-[inset_2px_0_0_0_gainsboro-gray,inset_-2px_0_0_0_gainsboro-gray]':
                        i === 0,
                      'shadow-[inset_-2.5px_0_0_0_gainsboro-gray]':
                        i !== 0 && array.length - 1 === i,
                      'shadow-[inset_-2px_0_0_0_gainsboro-gray]':
                        i !== 0 && array.length - 1 !== i,
                    })}
                    {...column.getHeaderProps()}
                    key={i}>
                    {
                      // Render the header
                      index === 0 ? (
                        <div className={'p-2'}>
                          <SelfExcludingSelectInput
                            column={column}
                            name={String(column.Header)}
                            key={i}
                            i={i}
                            rowsOptions={rowsOptions}
                          />
                        </div>
                      ) : (
                        column.render('Header')
                      )
                    }
                  </th>
                ))
              }
            </tr>
          ))
        }
      </thead>
      <motion.tbody {...getTableBodyProps()}>
        {
          // Loop over the table rows
          rows.map((row, index) => {
            // Prepare the row for display
            prepareRow(row)
            return (
              // Apply the row props
              <tr className={'mt-2'} {...row.getRowProps()} key={index}>
                {
                  // Loop over the rows cells
                  row.cells.map((cell, index) => {
                    // Apply the cell props
                    return (
                      <td
                        className={'font-medium px-2 py-2 text-xs'}
                        {...cell.getCellProps()}
                        key={index}>
                        {
                          // Render the cell contents
                          cell.render('Cell')
                        }
                      </td>
                    )
                  })
                }
              </tr>
            )
          })
        }
      </motion.tbody>
    </motion.table>
  )
}

export default CustomersUploadColumnsMapper
